import AlertError from "components/Alert/Error";
import type { DebtConsolidationFormValues } from "../types";
import type { FieldErrors } from "react-hook-form";

interface FormErrorsProps {
  errors: FieldErrors<DebtConsolidationFormValues>;
}

const FormErrors = ({ errors }: FormErrorsProps) => {
  if (Object.keys(errors).length > 0) {
    return (
      <AlertError title="There were errors with your submission">
        <>
          <p>
            Please ensure all required fields are completed before submitting.
          </p>
        </>
      </AlertError>
    );
  }
  return <></>;
};

export default FormErrors;
